import MyForm from '@/components/forms/my-form';

const MyPage = () => {
  return (
    <div className="flex flex-col gap-4 p-1 lg:p-8">
      <MyForm />
    </div>
  );
};

export default MyPage;
